import EventBus from '../../../shared/js/wirebox/event-bus'
import '../../../shared/js/wirebox/modules/storage'
import '../../../shared/js/wirebox/utilities/read-url-parameter'

const GClid = {
    
    /**
     * Run component
    */
    run() {
        EventBus.publish('read-url-parameter', {
            callback: (value) => {
                
                //Cancel if no gclid value in query string
                if (!value) {
                    return
                }
                
                //Get timestamp
                let
                    date = new Date(),
                    timestamp = Math.floor(date / 1000)
                
                //Store gclid value in local storage
                EventBus.publish('storage.write', {
                    key: 'gclid',
                    value: JSON.stringify({
                        timestamp: timestamp,
                        value: value
                    })
                })
                
            },
            name: 'gclid'
        })
    }
    
}

EventBus.subscribe('run-modules', GClid.run)

export default GClid